const pages = {
  dashboard: {
    title: "Dashboard",
    description: "Overview of projects, documents and recent activity",
  },
  appLauncher: {
    title: "All Apps",
    description: "Home screen — all apps, widgets and tools in one place",
  },
  layers: {
    title: "Hub",
    description: "Command hub — stats, recent activity, charts & quick access",
  },
  vcards: {
    title: "vCards",
    description: "Every instance and entity type in one place — unified list, type catalog and editor",
  },
  editor: {
    title: "Editor",
    description: "Tiptap document editor — Phase 2",
  },
  storyMap: {
    title: "vStory",
    description: "Drag & drop vStory board — Phase 3",
  },
  functionalMap: {
    title: "Functional Map",
    description: "GAM functional map — 3 levels × 5 functions with inline editing",
  },
  aiHub: {
    title: "AI Hub",
    description: "AI assistant with 5 work modes — Chat, Analyze, Write, Decompose & Work Manager",
  },
  aiHome: {
    title: "AI Home",
    description: "Entry point for the system agent, capability, prompt, and memory inventories",
  },
  aiAdvisors: {
    title: "AI Advisors",
    description: "18 expert advisors across different domains — persona selection and direct chat",
  },
  designSystem: {
    title: "Design System",
    description: "Design gallery — view, edit & inspire",
  },
  architecture: {
    title: "Architecture",
    description: "Mermaid diagram + tool table — vBrain.io architecture map",
  },
  plan: {
    title: "Plan",
    description: "5-phase roadmap — timeline with status and routes",
  },
  settings: {
    title: "Settings",
    description: "Language, theme & brand profile",
  },
  automations: {
    title: "Automation Hub",
    description: "Control panel for connections, scheduled jobs, webhooks & quick actions",
  },
  control: {
    title: "Control Center",
    description: "Overview — roadmap, dev log, architecture & recent updates",
  },
  siteControl: {
    title: "gam.co.il · Site Control",
    description: "Site map, sources, search, and publishing path in one place",
  },
  admin: {
    title: "Dev Log",
    description: "System overview, components & version tracking",
  },
  adminDataBrain: {
    title: "Data & Brain",
    description: "Internal Refine admin layer over Supabase data",
  },
  serverHealth: {
    title: "Server Health",
    description: "Real-time server health monitoring — system resources, Docker containers & services",
  },
  entities: {
    title: "Entities",
    description: "Entity & global field system — everything starts as a note",
  },
  entityFields: {
    title: "Field Library",
    description: "Global reusable fields across all entities",
  },
  wiki: {
    title: "Wiki",
    description: "Business knowledge base — the AI learns from this to understand your needs",
  },
  entityTypes: {
    title: "Entity Types",
    description: "Templates defining which fields to show for each note type",
  },
  grid: {
    title: "Grid",
    description: "Spreadsheet with formulas, cell coloring, and CSV export",
  },
  slides: {
    title: "Slides",
    description: "Presentation builder with image backgrounds, text overlays, and shapes",
  },
  boardroom: {
    title: "Board Room",
    description: "Multi-persona advisory panel — 8 AI expert advisors",
  },
  feeds: {
    title: "RSS Feeds",
    description: "Israeli construction & real estate news from leading sources",
  },
  import: {
    title: "Import",
    description: "Import CSV/Excel files into the entity system",
  },
  matching: {
    title: "Matching Engine",
    description: "AI matching between entities — workers, projects, contractors, and leads",
  },
  roadmap: {
    title: "Roadmap",
    description: "Business hierarchy — goals, portfolios, projects, sprints & tasks",
  },
  comms: {
    title: "Communication",
    description: "All messages, calls and conversations in one place",
  },
  documents: {
    title: "Documents",
    description: "Agreements, digital signatures and document archive",
  },
  weeklyPlanner: {
    title: "Weekly Planner",
    description: "Weekly planning, daily tasks & recurring templates",
  },
  audit: {
    title: "Audit Log",
    description: "Track all changes and actions in the system — legal evidence trail",
  },
  emailTemplates: {
    title: "Email Template Designer",
    description: "Email template editor — edit, dynamic variables, and preview",
  },
  vcanvas: {
    title: "vCanvas",
    description: "Freehand whiteboard — sketches, diagrams and visual ideas",
  },
  toolkit: {
    title: "Toolkit",
    description: "Development, AI and software tools",
  },
  courses: {
    title: "Course Library",
    description: "Personal courses with transcriptions, summaries and learning flashcards",
  },
  maintenance: {
    title: "Code Maintenance",
    description: "Professional code quality monitoring and maintenance system",
  },
  knowledge: {
    title: "Knowledge Base",
    description: "Business knowledge management and search — the source of truth for organizational information",
  },
  researchLibrary: {
    title: "Research Library",
    description: "External sources we trust — who wrote them, when they were checked, and what we decided",
  },
  knowledgeSources: {
    title: "Knowledge Sources",
    description: "Every knowledge source and what was actually harvested from it — books, wiki, conversations and GAM experience",
  },
  systemMonitoring: {
    title: "System Monitoring",
    description: "Real-time system performance monitoring and metrics dashboard",
  },
  honeypot: {
    title: "Honeypot Traps",
    description: "Silent tripwires: what is armed, when it was last checked, and what it caught",
  },
  iconLibrary: {
    title: "Icon Library",
    description: "Central management for icons, emoji and colors across all apps and folders",
  },
  vault: {
    title: "vPassword",
    description: "Home for secrets, keys and passwords — 1Password as source of truth, drift audit across all environments",
  },
  cost: {
    title: "Cost Control",
    description: "Budget & spend control for every paid service — limits, thresholds, and overage alerts",
  },
  health: {
    title: "System Health",
    description: "One overview of every live health source — automations, integrations, dev state, connections, server and task inbox",
  },
  identityResolver: {
    title: "Business & Contractor Resolver",
    description: "Inspect sources, rules and the SQL contract before the resolver engine is connected",
  },
} as const;
export default pages;
